<template>
  <div class="app-wrapper saas">
    <!-- <nav-bar></nav-bar> -->
    <DetailsNav></DetailsNav>
    <div
      class="banner"
      v-lazy:background-image="{
        src: require('./../../../../assets/T003/banners.png'),
        loading: require('./../../../../assets/T003/headBg-lazy1.jpg'),
      }"
    >
      <div class="msg">
        <div class="shan">
          <em>
            <img src="./../../../../assets/saas/logo.png" alt />
          </em>
          <span>SaaS-Export</span>
        </div>
        <div class="texts">{{ modelData.description }}</div>
        <pre-publish-widge           :data="modelData.lastUpdate"
          :links="baseData.pContent.demoTitleLinkGroup"></pre-publish-widge>
        <subject-flow-widge
          subject="Java学科"
          :project="modelData.name"
          :routerLink="routerLink"
        ></subject-flow-widge>
      </div>
    </div>
    <div class="advantage">
      <div class="bannerBox">
        <div class="industryInfos">
          <div class="money">
            <em>
              <img :src="modelData.tradeLogo" alt />
            </em>
            {{ modelData.tradename }}
          </div>
          <ul class="industryList clear">
            <li>
              <p class="fontsize">
                {{ baseInfoTitle1.num }}
                <em>{{ baseInfoTitle1.unit }}</em>
              </p>
              <p>{{ baseInfoTitle1.type }}</p>
            </li>
            <li>
              <p class="fontsize">
                {{ baseInfoTitle2.num }}
                <em>{{ baseInfoTitle2.unit }}</em>
              </p>
              <p>{{ baseInfoTitle2.type }}</p>
            </li>
            <li>
              <p class="fontsize">
                {{ baseInfoTitle3.num }}
                <em>{{ baseInfoTitle3.unit }}</em>
              </p>
              <p>{{ baseInfoTitle3.type }}</p>
            </li>
            <li>
              <p class="fontsize">
                {{ baseInfoTitle4.num }}
                <em>{{ baseInfoTitle4.unit }}</em>
              </p>
              <p>{{ baseInfoTitle4.type }}</p>
            </li>
            <li>
              <p class="fontsize">
                {{ baseInfoTitle5.num }}
                <em>{{ baseInfoTitle5.unit }}</em>
              </p>
              <p>{{ baseInfoTitle5.type }}</p>
            </li>
          </ul>
          <div
            class="temVideo"
            @click="handleVideo(modelData, event)"
            v-if="modelData.pVideoUrl"
          >
            <em>
              <img src="./../../../../assets/T003/video.png" alt />
            </em>
            <p>项目介绍</p>
          </div>
        </div>
      </div>
      <div class="bannerBox" style="width:1290px">
        <title-widge title="畅想体验 Java 真项目" style="padding-top:115px">
          <!-- <span style="margin-left: 20px;margin-right: 15px;">才是</span>
          <span style="color: red;">真项目</span> -->
        </title-widge>
        <div class="temTabs">
          <el-tabs v-model="activeTab">
            <el-tab-pane label name="first">
              <span slot="label">管理后台</span>
              <div class="tabCon conBoxModel">
                <div class="foodCon">
                  <viewer
                    :images="modelData.pAdImages"
                    class="imgVideo appScroll"
                    v-if="
                      this.pVideoUrlData.length !== 0 ||
                        modelData.pAdImages.length !== 0
                    "
                  >
                    <swiper :options="swiperOption">
                      <template v-if="modelData.pAdImages.length !== 0">
                        <!-- <swiper-slide
                            class="1"
                            id="index"
                            v-for="(item, index) in modelData.pAdImages"
                            :key="index"
                            style="width:434px !important;height:341px !important"
                          >
                            <div class="imgBg">
                              <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" />
                            </div>
                            
                        </swiper-slide>-->
                        <swiper-slide
                          class="1"
                          id="index"
                          style="width:434px !important;height:341px !important"
                        >
                          <div class="imgBg">
                            <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                            <img
                              src="./../../../../assets/saas/export/web1.png"
                              class="imgPosition"
                            />
                          </div>
                        </swiper-slide>

                        <swiper-slide
                          class="1"
                          id="index"
                          style="width:434px !important;height:341px !important"
                        >
                          <div class="imgBg">
                            <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                            <img
                              src="./../../../../assets/saas/export/web2.png"
                              class="imgPosition"
                            />
                          </div>
                        </swiper-slide>

                        <swiper-slide
                          class="1"
                          id="index"
                          style="width:434px !important;height:341px !important"
                        >
                          <div class="imgBg">
                            <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                            <img
                              src="./../../../../assets/saas/export/web3.png"
                              class="imgPosition"
                            />
                          </div>
                        </swiper-slide>

                        <swiper-slide
                          class="1"
                          id="index"
                          style="width:434px !important;height:341px !important"
                        >
                          <div class="imgBg">
                            <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                            <img
                              src="./../../../../assets/saas/export/web4.png"
                              class="imgPosition"
                            />
                          </div>
                        </swiper-slide>

                        <swiper-slide
                          class="1"
                          id="index"
                          style="width:434px !important;height:341px !important"
                        >
                          <div class="imgBg">
                            <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                            <img
                              src="./../../../../assets/saas/export/web1.png"
                              class="imgPosition"
                            />
                          </div>
                        </swiper-slide>

                        <swiper-slide
                          class="1"
                          id="index"
                          style="width:434px !important;height:341px !important"
                        >
                          <div class="imgBg">
                            <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                            <img
                              src="./../../../../assets/saas/export/web2.png"
                              class="imgPosition"
                            />
                          </div>
                        </swiper-slide>
                      </template>
                      <template
                        v-if="
                          this.pVideoUrlData.length !== 0 ||
                            modelData.pAdImages.length !== 0
                        "
                      >
                        <div class="swiper-pagination" slot="pagination"></div>
                        <div
                          class="swiper-button-prev"
                          slot="button-prev"
                        ></div>
                        <div
                          class="swiper-button-next"
                          slot="button-next"
                        ></div>
                      </template>
                    </swiper>
                  </viewer>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <display-button-widge
            :links="baseData.pContent.demoTitleLinkGroup"
            :lastUpdate="modelData.lastUpdate"
          ></display-button-widge>
        </div>
      </div>
    </div>
    <div class="content">
      <ul class="navs" :class="[isSelected]" ref="nvalist">
        <template v-for="(item, index) in navList">
          <li :key="index" :class="index === currentIndex ? 'active' : '11'">
            <a href="javascript:;" @click="selectMenu(index, $event)">
              <em></em>
              {{ item.name }}
            </a>
          </li>
        </template>
      </ul>
      <div class="containers" ref="downContent">
        <div class="floor cont1" ref="div1">
          <div class="title">
            <title-widge
              title="最典型国际货代出口SaaS平台课程"
              subTitle="设置典型国际货代出口场景，采用基于SaaS平台的开发方式，学与用紧密结合"
            ></title-widge>
          </div>
          <div class="bigbox">
            <div class="imgs">
              <img
                v-lazy="{
                  src: require('./../../../../assets/saas/pay.png'),
                  loading: require('./../../../../assets/saas/projectAdvantage-lazy.png'),
                }"
                alt
              />
            </div>
            <div class="text">
              <p></p>
              <div>
                1.基于SaaS模式的软件开发流程、数据库设计及基于SaaS模式的权限设计方案。
                <br />2.可以汇总数据，实现各种报表的智能化生成。主要包括传统的Excel报表及PDF报表生成；也可以是前端图形报表及POI报表的优化技术。
                <br />3.前端使用JasperReport、Echarts进行构建。
              </div>
            </div>
          </div>
        </div>
        <div class="floor cont2" ref="div2">
          <div class="title">
            <title-widge
              title="如果您是他们一员，欢迎随时来学习"
              subTitle="在校大学生／想强化技能的职场人士／职场小白"
            ></title-widge>
          </div>
          <div class="studyMains">
            <ul>
              <li>
                <div class="iconbg icon1"></div>
                <p class="fchild">在校大学生</p>
                <p>
                  想进入IT行业
                  <br />想提前学习技术 <br />想有更高的职场起点
                </p>
              </li>
              <li>
                <div class="iconbg icon2"></div>
                <p class="fchild">想强化技能的职场人士</p>
                <p>
                  想在企业服务领域深入发展
                  <br />想了解更多样的业务场景 <br />想突破职业瓶颈
                </p>
              </li>
              <li>
                <div class="iconbg icon3"></div>
                <p class="fchild">职场小白</p>
                <p>
                  想选择更有前景的行业
                  <br />想学习更有潜力的技术 <br />想飞速升高自身本领
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="floor cont3" ref="div3">
          <div class="title">
            <title-widge
              title="完善功能，打造国际货代“真”项目"
              subTitle="企业先试用后付费，后台实时追踪货单、合同、产品销量等，国际货代流程全覆盖"
            ></title-widge>
          </div>
          <div class="imgBox">
            <p>功能架构图</p>
            <img
              v-lazy="{
                src: functionaUrl,
                loading: require('./../../../../assets/drawing.jpg'),
              }"
            />
          </div>
        </div>
        <div class="floor cont4" ref="div4">
          <div class="title">
            <title-widge
              title="超前沿的技术，构筑功能运转核心引擎"
              subTitle="国际货物代理出口技术专家，历时6个月搭建紧跟市场趋势的技术架构"
            ></title-widge>
          </div>
          <div class="pat">
            <div class="imgBox">
              <p>技术架构图</p>
              <img
                v-lazy="{
                  src: technicalUrl,
                  loading: require('./../../../../assets/drawing.jpg'),
                }"
              />
            </div>
            <!-- <div class="itemListss">
              <ul>
                <li>
                  <em></em>采用 Elasticsearch Geo实现地理位置查询。
                </li>
                <li>
                  <em></em>采用 RocketMQ 作为消息服务中间件。
                </li>
                <li>
                  <em></em>采用 MongoDB 进行海量数据的存储。
                </li>
                <li>
                  <em></em>采用 Spark + Mllib 实现智能推荐。
                </li>
                <li>
                  <em></em>采用环信服务实现即时通讯。
                </li>
                <li>
                  <em></em>采用分布式文件系统存储小视频数据。
                </li>
                <li>
                  <em></em>用户支付采用支付宝扫码等常用支付方式。
                </li>
                <li>
                  <em></em>采用 Apache Dobbo 作为微服务架构技术。
                </li>
                <li>
                  <em></em>采用 Spring Boot + Mybatis 实现系统主架构。
                </li>
                <li>
                  <em></em>采用 Redis 集群实现缓存的高可用。
                </li>
              </ul>
            </div>-->
          </div>
        </div>
        <div class="floor cont5" ref="div5" 
            v-lazy:background-image="{
            src: require('./../../../../assets/saas/banner.png'),
          }"
        >
          <div class="title">
            <title-widge
              title="企业服务解决方案，拓宽学员知识面"
              subTitle="9大解决方案，覆盖shiro、云存储、数据库设计等，提升学员跨行业技术开发能力"
              titleColor="#fff"
              subTitleColor="#fff"
            ></title-widge>
          </div>
        </div>
        <div class="floor cont6" ref="div6">
          <div class="title">
            <title-widge
              title="由简入繁，节奏适中，丰富经验"
              subTitle="沉淀为符合知识吸收规律的学习路线"
            ></title-widge>
          </div>
          <div class="conts">
            <div class="studyRoute">
              <div class="outlineBox">
                <el-tabs :tab-position="tabPosition" style="height: 669px;">
                  <el-tab-pane
                    label
                    v-for="(item, index) in courseOutData"
                    :key="index"
                  >
                    <div slot="label" class="outlineTitle">
                      <p>
                        {{ getCaptionReg(item.titles) }}({{
                          getCaption(item.titles)
                        }})
                      </p>

                      <span :title="getCaption2(item.titles)">{{
                        getCaption2(item.titles)
                      }}</span>
                    </div>
                    <div class="outlineeInfo">
                      <div v-for="(val, num) in item.desc" :key="num">
                        <em class="courseOutTitle">{{ val.title }}</em>

                        <ul class="courseOutList">
                          <li
                            v-for="(v, n) in val.conten.split(/\↵|\r|\n|\r\n/)"
                            :key="n"
                          >
                            <font :title="v">{{ v }}</font>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <!-- <div
                class="studyBtn"
                style="cursor:pointer"
                @click="qimoChatClick()"
              >
                <a>马上学习</a>
              </div> -->
            </div>
          </div>
        </div>
        <div class="floor cont7" ref="div7" v-if="teacherUrls.length > 0">
          <div class="title">
            <title-widge
              title="研发力量强大 汇聚行业实战专家"
              subTitle="拒绝空谈理论，给你真实有用的企业开发实战经验"
            ></title-widge>
          </div>
          <div class="list">
            <common-techer-display-widge
              :imgs="teacherUrls"
            ></common-techer-display-widge>
          </div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
    <bottom-widge></bottom-widge>
  </div>
</template>

<script>
// import navBar from "./../../../components/navBar";
import DetailsNav from "./../../../components/detailsNav.vue";
import bottomWidge from "./../../../components/bottomWidge";
import prePublishWidge from './../common/components/prePublishWidge'
import displayButtonWidge from "./../common/components/displayButtonWidge";
import baseApi from "@/base/baseApi";
import { Content } from "../../../../gqlapi/ContentDetail.js";
import MenuAdd from "./../../../components/video";
import commonTecherDisplayWidge from "./../common/components/techerDisplayWidge";
import subjectFlowWidge from "./../../../components/subjectFlowWidge";
import {
  strToObj,
  elTabsAddEventListener,
  lieBiaoToTeachers,
} from "./../../../js/tools";
import titleWidge from "./components/titleWidge";
export default {
  name: "layout",
  components: {
    // navBar,
    DetailsNav,
    bottomWidge,
    prePublishWidge,
    MenuAdd,
    commonTecherDisplayWidge,
    subjectFlowWidge,
    displayButtonWidge,
    titleWidge,
  },
  data() {
    return {
      activeTab: "first",
      tabPosition: "left",
      currents: -1,
      activeIndex: -1,
      isSelected: "navon0-selected",
      activeName: "1",
      active: "active",
      detailId: "",
      menuData: [],
      baseData: {
        pContent: {},
      },
      baseInfo: [],
      courseOutData: [],
      highlightsData: [],
      solutionData: [],
      currentOffset: 0,
      windowSize: 0,
      paginationFactor: 235,
      functionaUrl: "",
      technicalUrl: "",
      testImage: "",
      productArchitectureUrl: "",
      productStructureUrl: "",
      projectSummaryUrl: "",
      modelData: {
        name: "",
        tradename: "",
        tradeLogo:"",
        platforms: "",
        lastUpdate: "",
        description: "",
        pVideoUrl: "",
        videologoImage: "",
        pAdImages: "",
        logoImage: "",
        version: "",
      },
      navList: [
        {
          index: 0,
          name: "项目优势",
        },
        {
          index: 1,
          name: "适学人群",
        },
        {
          index: 2,
          name: "功能架构",
        },
        {
          index: 3,
          name: "技术架构",
        },
        {
          index: 4,
          name: "解决方案",
        },
        {
          index: 5,
          name: "学习路线",
        },
        {
          index: 6,
          name: "师资力量",
        },
      ],
      pVideoUrlData: [],
      listHeight: [],
      currentIndex: 0,
      distance: 0,
      total: 0,
      step: 0,
      seen: false,
      current: 0,
      baseHeight: 1000,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 26,
        slidesPerGroup: 2,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled-class",
        },
      },
      projectToolsl: [],
      teacherUrls: [],
      baseInfoTitle1: {
        num: "",
        unit: "",
        type: "",
      },
      baseInfoTitle2: {
        num: "",
        unit: "",
        type: "",
      },
      baseInfoTitle3: {
        num: "",
        unit: "",
        type: "",
      },
      baseInfoTitle4: {
        num: "",
        unit: "",
        type: "",
      },
      baseInfoTitle5: {
        num: "",
        unit: "",
        type: "",
      },
    };
  },
  watch: {
    $route() {
      this.getData(17);
    },
  },

  created() {
    this.menuData = baseApi.menuList;
    this.detailId = this.$route.query.id;
    this.getData(17);
    this.activeName = this.$route.query.tab;
    this.$nextTick(() => {
      this._initScroll();
      setTimeout(() => {
        // this._calculateHeight();
        //document.body.scrollTop = 0;
        //document.documentElement.scrollTop = 0;
      }, 3000);
    });
  },
  computed: {
    routerLink() {
      return {
        path: "/java",
      };
    },
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor *
          -1 *
          (this.modelData.pAdImages.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    qimoChatClick() {
      window.qimoChatClick();
    },
    handleVideo(url, e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(url);
    },
    getBaseHeight() {
      setTimeout(() => {
        this.baseHeight = document.querySelector(".content").offsetTop;
      }, 1000);
    },
    getData(detailId) {
      this.$axios.post('/api',{
            operationName: "Content",
            variables:{
              id: detailId,
            },
            query: Content
        })
        .then((res) => {
          this.getBaseHeight();
          this.baseData = res.data.data;
          this.teacherUrls = lieBiaoToTeachers(
            res.data.data.pContent.detailsList,
            res.data.data.pContent.teachers
          );
          let pContent = res.data.data.pContent;
          this.baseInfoTitle1 = strToObj(pContent.baseInfoTitle1);
          this.baseInfoTitle2 = strToObj(pContent.baseInfoTitle2);
          this.baseInfoTitle3 = strToObj(pContent.baseInfoTitle3);
          this.baseInfoTitle4 = strToObj(pContent.baseInfoTitle4);
          this.baseInfoTitle5 = strToObj(pContent.baseInfoTitle5);
          //项目情况
          this.modelData.name = this.baseData.pContent.name;
          this.modelData.version = this.baseData.pContent.version;
          this.modelData.tradename = pContent.industryTitle ? pContent.industryTitle : pContent.trade? pContent.trade.name : "";
          this.modelData.tradeLogo = pContent.industryIcon ? pContent.industryIcon.url:  pContent.trade? pContent.trade.iconFile ? pContent.trade.iconFile.url : "" : "";

          this.modelData.platforms = this.baseData.pContent.platforms;
          this.modelData.lastUpdate = this.baseData.pContent.lastUpdate;
          this.modelData.description = this.baseData.pContent.description;
          this.modelData.pVideoUrl = this.baseData.pContent.pVideoUrl;

          this.modelData.pAdImages = this.baseData.pContent.pAdImages;

          this.modelData.testImage = this.baseData.pContent.testArchitectureImage;

          if (this.baseData.pContent.videoLogoImage === null) {
            this.modelData.videologoImage = this.baseData.pContent.videoLogoImage;
          } else {
            this.modelData.videologoImage = this.baseData.pContent.videoLogoImage.url;
          }
          var pvideoData = [];
          if (this.modelData.pVideoUrl !== null) {
            var pvideo = {
              videoUrl: this.modelData.pVideoUrl,
              videoLogoImage: this.modelData.videologoImage,
            };
            pvideoData.push(pvideo);
            this.pVideoUrlData = pvideoData;
          } else {
            this.pVideoUrlData.length = 0;
          }
          //项目logo
          if (this.baseData.pContent.detailLogoImage === null) {
            debugger;
            this.modelData.logoImage = this.baseData.pContent.detailLogoImage;
          } else {
            this.modelData.logoImage = this.baseData.pContent.detailLogoImage.url;
          }
          //测试框架图
          if (this.baseData.pContent.testArchitectureImage === null) {
            this.testImage = this.baseData.pContent.testArchitectureImage;
          } else {
            this.testImage = this.baseData.pContent.testArchitectureImage.url;
          }
          //功能架构图
          if (this.baseData.pContent.functionalArchitectureDiagram === null) {
            this.functionaUrl = this.baseData.pContent.functionalArchitectureDiagram;
          } else {
            this.functionaUrl = this.baseData.pContent.functionalArchitectureDiagram.url;
          }
          //技术架构图
          if (this.baseData.pContent.technicalArchitectureDiagram === null) {
            this.technicalUrl = this.baseData.pContent.technicalArchitectureDiagram;
          } else {
            this.technicalUrl = this.baseData.pContent.technicalArchitectureDiagram.url;
          }

          //产品架构图
          if (this.baseData.pContent.productArchitectureDiagramImage === null) {
            this.productArchitectureUrl = this.baseData.pContent.productArchitectureDiagramImage;
          } else {
            this.productArchitectureUrl = this.baseData.pContent.productArchitectureDiagramImage.url;
          }

          //产品结构图
          if (this.baseData.pContent.productStructureImage === null) {
            this.productStructureUrl = this.baseData.pContent.productStructureImage;
          } else {
            this.productStructureUrl = this.baseData.pContent.productStructureImage.url;
          }

          //项目总结
          if (this.baseData.pContent.projectSummaryImage === null) {
            this.projectSummaryUrl = this.baseData.pContent.projectSummaryImage;
          } else {
            this.projectSummaryUrl = this.baseData.pContent.projectSummaryImage.url;
          }

          //所有软件
          if (this.baseData.pContent.tools.length > 0) {
            this.projectToolsl = this.baseData.pContent.tools;
          }
          //基本信息
          var baseInfoTitle = [
            this.baseData.pContent.baseInfoTitle1,
            this.baseData.pContent.baseInfoTitle2,
            this.baseData.pContent.baseInfoTitle3,
            this.baseData.pContent.baseInfoTitle4,
            this.baseData.pContent.baseInfoTitle5,
            this.baseData.pContent.baseInfoTitle6,
            this.baseData.pContent.baseInfoTitle7,
            this.baseData.pContent.baseInfoTitle8,
          ];
          var baseInfoDesc = [
            this.baseData.pContent.baseInfoDesc1,
            this.baseData.pContent.baseInfoDesc2,
            this.baseData.pContent.baseInfoDesc3,
            this.baseData.pContent.baseInfoDesc4,
            this.baseData.pContent.baseInfoDesc5,
            this.baseData.pContent.baseInfoDesc6,
            this.baseData.pContent.baseInfoDesc7,
            this.baseData.pContent.baseInfoDesc8,
          ];
          this.infoData(baseInfoTitle, baseInfoDesc, this.baseInfo, "base");
          //技术亮点
          var highlightsData;
          if (this.baseData.pContent.technicalHighlights !== null) {
            highlightsData = this.baseData.pContent.technicalHighlights.split(
              /↵|\n/
            );
            this.forData(highlightsData, this.highlightsData);
          } else {
            this.highlightsData.length = 0;
          }

          //解决方案
          var soluData;
          if (this.baseData.pContent.technologySolution !== null) {
            soluData = this.baseData.pContent.technologySolution.split(/↵|\n/);
            this.forData(soluData, this.solutionData);
          } else {
            this.solutionData.length = 0;
          }
          //课程大纲
          var courseOutlineTitle = [
            this.baseData.pContent.courseOutlineTitle1,
            this.baseData.pContent.courseOutlineTitle2,
            this.baseData.pContent.courseOutlineTitle3,
            this.baseData.pContent.courseOutlineTitle4,
            this.baseData.pContent.courseOutlineTitle5,
            this.baseData.pContent.courseOutlineTitle6,
            this.baseData.pContent.courseOutlineTitle7,
            this.baseData.pContent.courseOutlineTitle8,
            this.baseData.pContent.courseOutlineTitle9,
            this.baseData.pContent.courseOutlineTitle10,
            this.baseData.pContent.courseOutlineTitle11,
            this.baseData.pContent.courseOutlineTitle12,
            this.baseData.pContent.courseOutlineTitle13,
            this.baseData.pContent.courseOutlineTitle14,
            this.baseData.pContent.courseOutlineTitle15,
            this.baseData.pContent.courseOutlineTitle16,
            this.baseData.pContent.courseOutlineTitle17,
            this.baseData.pContent.courseOutlineTitle18,
            this.baseData.pContent.courseOutlineTitle19,
            this.baseData.pContent.courseOutlineTitle20,
          ];
          var courseOutlineDesc = [
            this.baseData.pContent.courseOutlineDesc1,
            this.baseData.pContent.courseOutlineDesc2,
            this.baseData.pContent.courseOutlineDesc3,
            this.baseData.pContent.courseOutlineDesc4,
            this.baseData.pContent.courseOutlineDesc5,
            this.baseData.pContent.courseOutlineDesc6,
            this.baseData.pContent.courseOutlineDesc7,
            this.baseData.pContent.courseOutlineDesc8,
            this.baseData.pContent.courseOutlineDesc9,
            this.baseData.pContent.courseOutlineDesc10,
            this.baseData.pContent.courseOutlineDesc11,
            this.baseData.pContent.courseOutlineDesc12,
            this.baseData.pContent.courseOutlineDesc13,
            this.baseData.pContent.courseOutlineDesc14,
            this.baseData.pContent.courseOutlineDesc15,
            this.baseData.pContent.courseOutlineDesc16,
            this.baseData.pContent.courseOutlineDesc17,
            this.baseData.pContent.courseOutlineDesc18,
            this.baseData.pContent.courseOutlineDesc19,
            this.baseData.pContent.courseOutlineDesc20,
          ];
          this.infoData(
            courseOutlineTitle,
            courseOutlineDesc,
            this.courseOutData,
            "out"
          );

          var couseOutBase = {};
          var courseOutData = [];
          // 后端数据处理
          this.courseOutData.forEach(function(item) {
            if (item.desc !== null && item.desc !== "") {
              var items = item.desc.split(/;|；/);
              var descData = items.map((val) => {
                var arr = val.split("：");
                return { title: arr[0], conten: arr[1] };
              });
              couseOutBase = {
                titles: item.title
                  .replace(/\[.*?\]/g, "")
                  .replace(/\(.*?\)/g, ""),
                desc: descData,
                video: item.video,
              };
              courseOutData.push(couseOutBase);
            }
          });
          this.courseOutData = courseOutData;
          setTimeout(function() {
            elTabsAddEventListener(document, courseOutData.length);
          }, 1000);
          if (this.baseInfo.length === 0) {
            this.$refs.div2.style.display = "none";
          }
          if (this.highlightsData.length === 0) {
            this.$refs.div3.style.display = "none";
          }

          if (this.solutionData.length === 0) {
            this.$refs.div5.style.display = "none";
          }

          if (this.functionaUrl == null) {
            this.$refs.div6.style.display = "none";
          }
          if (this.technicalUrl == null) {
            this.$refs.div7.style.display = "none";
          }
        })
        .catch((err) => {
          console.log(999, err);
        });
    },
    getCaption(obj) {
      if (obj.lastIndexOf("（") > 0) {
        obj = obj.substring(obj.indexOf("（") + 1, obj.indexOf("）"));
        return obj;
      }
    },
    getCaption2(obj) {
      if (obj.lastIndexOf("（") > 0) {
        obj = obj.substring(obj.indexOf("：") + 1, obj.indexOf("（"));
        return obj;
      }
    },
    getCaptionReg(obj) {
      obj = obj.split("：")[0];
      return obj;
    },
    infoData(title, desc, items, name) {
      var obj = {};
      for (var f = 0; f < title.length; f++) {
        for (var d = 0; d < desc.length; d++) {
          if (f === d) {
            if (title[f] !== null && title[f] !== "") {
              if (name === "base") {
                var baseInfo = desc[d];
                if (desc[d] !== null && desc[d] !== "") {
                  baseInfo = desc[d].split("\n");
                } else {
                  baseInfo = desc[d];
                }
                obj = {
                  title: title[f],
                  desc: baseInfo,
                };
              } else {
                var videoName = title[f].lastIndexOf("[");
                var videoUrl = title[f].lastIndexOf("(");

                var names = "";
                var urls = "";
                if (videoName > 0) {
                  names = title[f].substring(
                    title[f].indexOf("[") + 1,
                    title[f].indexOf("]")
                  );
                }
                if (videoUrl > 0) {
                  urls = title[f].substring(
                    title[f].indexOf("(") + 1,
                    title[f].indexOf(")")
                  );
                }
                var videoObj = {};

                videoObj = {
                  name: names,
                  url: urls,
                };
                obj = {
                  title: title[f],
                  desc: desc[d],
                  video: videoObj,
                };
              }
              items.push(obj);
            }
          }
        }
      }
    },
    forData(data, items) {
      for (var i = 0; i < data.length; i++) {
        if (data[i] !== "") {
          items.push(data[i]);
        }
      }
    },
    selectMenu(index) {
      this.distance =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let jump = document.getElementsByClassName("floor");
      let total = jump[index].offsetTop;
      this.total = total + this.baseHeight;
      if (index === 1 || index === 2 || index === 3) {
        this.total = this.total - 150;
      } else if (index === 4) {
        this.total = this.total - 50;
      } else if (index === 6) {
        this.total = this.total - 150;
      }
      this.step = 100;
      if (this.total > this.distance) {
        this.smoothDown();
      } else {
        this.smoothUp();
      }
    },
    _initScroll() {},
    scrool(pos) {
      console.log(pos);
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      for (var i = 0; i < this.listHeight.length; i++) {
        if (
          this.listHeight[i] < scrolled + 180 &&
          scrolled + 180 < this.listHeight[i + 1]
        ) {
          this.currentIndex = i;
          return false;
        }
      }
    },
    smoothDown() {
      if (this.distance < this.total) {
        this.distance += this.step;
        document.body.scrollTop = this.distance;
        document.documentElement.scrollTop = this.distance;
        if (this.total - this.distance > this.step) {
          setTimeout(this.smoothDown, 10);
        } else {
          document.body.scrollTop = this.total;
          document.documentElement.scrollTop = this.total;
        }
      }
    },
    smoothUp() {
      if (this.distance > this.total) {
        this.distance -= this.step;
        document.body.scrollTop = this.distance;
        document.documentElement.scrollTop = this.distance;
        if (this.distance - this.total > this.step) {
          setTimeout(this.smoothUp, 10);
        } else {
          document.body.scrollTop = this.total;
          document.documentElement.scrollTop = this.total;
        }
      }
    },
    // _calculateHeight() {
    //   if(this.$refs.downContent!==undefined){
    //     let foodList = this.$refs.downContent.getElementsByClassName(
    //       "floor"
    //     );
    //     let height = 0;
    //     this.listHeight.push(height);
    //     for (let i = 0; i < foodList.length; i++) {
    //       let item = foodList[i];
    //       height += item.clientHeight;
    //       this.listHeight.push(height);
    //     }
    //   }
    // },
    enter(index) {
      this.seen = true;
      this.current = index;
    },
    leave() {
      this.seen = false;
      this.current = null;
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    setIndex(index) {
      if (this.activeIndex === index) {
        this.currents = -1;
        this.activeIndex = -1; //在这里就将它赋值为-1  由于：-1 !=  index 所以其他内容隐藏 ，被点击的则打开
      } else {
        this.activeIndex = index; //这里是把index赋值给isShow，isShow=index则显示
        this.currents = index;
      }
    },

    handleLink(link, e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      window.open(link.video.url, "_self");
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let divContainers =document.querySelector(".containers");
      if( !divContainers ){
        return;
      }
      let jump = divContainers.children;
      let baseHeight = this.baseHeight - 10;
      for (var i = 0; i < jump.length; i++) {
        if (i === 0) {
          if (scrollTop > jump[i].offsetTop + baseHeight) {
            this.currentIndex = i;
          }
        } else if (i === 4 || i === 5) {
          if (scrollTop > jump[i].offsetTop + baseHeight - 50) {
            this.currentIndex = i;
          }
        } else {
          if (scrollTop > jump[i].offsetTop + baseHeight - 150) {
            this.currentIndex = i;
          }
        }
      }
      if (scrollTop > this.baseHeight - 38) {
        document.querySelector(".navs").style = "position:fixed;top:0";
      } else {
        document.querySelector(".navs").style = " position:absolute";
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  //mounted() {
  //    var self = this;
  //    var liIds = [];
  //    var lis =this.menuData;
  //    for (var i = 0; i < lis.length; i++) {
  //      liIds.push('navon'+i);
  //    }
  //    var $scrollBox = document.querySelector('.container');

  //    var scrollCallback = self.debounce(function () {
  //      var top = $scrollBox.scrollTop; //设置变量top,表示当前滚动条到顶部的值
  //      var tt = $scrollBox.clientHeight; //设置变量tt,表示当前滚动窗口高度的值
  //      var num = 0;
  //      for (var n = 0; n < 7; n++) {
  ////在此处通过判断滚动条到顶部的值和当前窗口高度的关系
  ////（当前窗口的n倍 <= top <= 当前窗口的n+1倍）来取得和导航索引值的对应关系
  //        if (top >= n * tt && top <= (n + 1) * tt) {
  //          num = n;
  //        }
  //        self.isSelected = liIds[num] + '-selected';
  //      }

  //    }, 100)
  //    $scrollBox.addEventListener('scroll', scrollCallback)

  //  }
};
</script>

<style lang="scss">
.saas {
  .temTabs {
    .el-tabs {
      margin: 0;
    }
    .el-tabs__content {
      overflow: visible;
      width: 100%;
    }
    .el-tabs__item {
      padding-bottom: 15px !important;
      padding: 0;
      margin: 0 50px;
      span {
        padding: 0;
        margin: 0 -25px;
      }
      &:hover {
        color: #0078ff;
      }
    }
    .el-tabs__item.is-active {
      color: #0078ff !important;
      background: none !important;
      border-bottom: 5px solid #0078ff;
      border-radius: 0 !important;
      padding-bottom: 40px !important;
    }
    .el-tabs__header {
      text-align: center;
      padding: 58px 0 0px;
      margin-bottom: 10px;
      .el-tabs__item {
        font-size: 24px;
      }
    }
    .el-tabs__nav {
      float: none;
    }
    .foodCon {
      background: #fff;
    }
    .divProjectDisplay {
      padding-top: 29px;
      padding-bottom: 41px;
    }
  }
  .content {
    .containers {
      .cont6 {
        .conts {
          width: 1200px;
          height: 710px;
          background: white;
          margin: 0 auto;
          margin-top: 80px;
          margin-bottom: 80px;
          box-shadow: 9px 16px 84px 0px rgba(194, 194, 194, 0.48);
          .el-tabs__content {
            padding: 37px 50px 10px 50px;
            border: 1px solid #0078ff;
            margin-top: 64px;
            height: 530px;
            overflow-y: auto;
          }
          .el-icon-arrow-left:before {
            content: "";
          }
          .el-tabs__nav-prev,
          .el-tabs__nav-next {
            i {
              width: 16px;
              height: 18px;
              transform: none;
              cursor: pointer;
            }
          }
          .el-tabs__nav-prev {
            margin-top: 29px;
            right: 5px;
            .el-icon-arrow-left {
              &:hover {
                background: url(~@/assets/T003/shang_hover.png) center center /
                  16px 18px no-repeat;
              }
            }
          }
          .el-tabs__nav-next {
            height: 58px;
            right: 6px;
            .el-icon-arrow-right {
              margin-top: 17px;
              background: url(~@/assets/T003/xia.png) center center / 16px 18px
                no-repeat;
              &:hover {
                background: url(~@/assets/T003/xia_hover.png) center center /
                  16px 18px no-repeat;
              }
            }
          }
          .el-tabs__item {
            height: 110px !important;
            border-radius: 17px !important;
            text-align: left !important;
            margin-right: 14px;
            background: #fff;
            .dataNum {
              padding-left: 10px;
            }
          }
          .el-tabs__item.is-active {
            span {
              background-color: #217cf6;
              color: white;
            }
          }
          .el-tabs__item p {
            color: #217cf6;
            font-size: 16px;
          }
          .el-tabs__item span {
            width: 239px;
            height: 55px;
            border-radius: 4px;
            vertical-align: middle;
            display: inline-block !important;
            background-color: #eee;
            line-height: 55px;
            padding: 0 18px;
            box-sizing: border-box;
            margin-top: 7px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
          .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
          .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
          .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
            //  padding-left: 20px !important;
          }
          .el-tabs__active-bar {
            display: none;
          }
          .el-tabs__nav-wrap {
            padding: 58px 0;
          }
          .el-tabs__nav-wrap::after {
            background: none !important;
          }
          .el-tabs__header {
            margin-top: 10px !important;
            margin-bottom: 18px;
          }
          .el-tabs {
            margin: 0 80px;
          }
          .studyRoute {
            margin-top: 90px;
            position: relative;
            .outlineeInfo {
              .courseOutTitle {
                display: block;
                background: rgb(248, 245, 245);
                border-radius: 4px;
                height: 38px;
                line-height: 38px;
                padding: 0 12px;
                color: #217cf6;
                font-weight: 600;
              }
              .courseOutList {
                padding: 33px 0 20px;
                margin: 0 12px;
                li {
                  color: black;
                  display: inline-block;
                  width: 50%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-top: -10px;
                  white-space: nowrap;
                  &:first-child {
                    display: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "./scss/saas";
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.bottom {
  p {
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
.activeClass {
  transform: rotate(90deg);
}
.appScroll {
  border-radius: 5px;
  .swiper-slide {
    width: 296px;
    height: 608px;
    // box-shadow:rgba(0,0,0,.3) 0px 0px 15px;
    box-shadow: 0px 4px 14px 0px rgba(184, 184, 184, 0.77);
    background: #faf9ff;
    border-radius: 5px;
    h2 {
      padding: 35px 0 20px;
      text-align: center;
    }
  }
}
.pcScroll {
  .swiper-slide {
    width: 600px;
    height: 307px;
  }
}
.swiper-slide-invisible-blank {
  display: none;
}
.conBoxModel .appScroll .imgPosition {
  // width: 276px;
  // height: 508px;
}
.imgBg {
  width: 434px;
  height: 340px;
  background: #fff;
  border: none;
  border-radius: 5px;
  overflow: hidden;
}
.menghu {
  font-weight: 400;
  cursor: pointer;
}
.menghu:hover {
  color: #0078ff;
  font-weight: 400;
}
.xmk {
  color: #0078ff;
  font-weight: 400;
}
</style>
